<template>
  <div class="ring-loader">
    <div class="ring-loader-container">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RingLoader",
  };
</script>
<style scoped lang="scss">

  .ring-loader {

    .ring-loader-container {
      display: inline-block;
      position: relative;
      width: 39px;
      height: 21px;

      div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 54px;
        height: 54px;
        margin: 5px;
        border: 2px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff #0c315e #0c315e #0c315e;
      }

      div:nth-child(1) {
        animation-delay: -0.45s;
      }

      div:nth-child(2) {
        animation-delay: -0.3s;
      }

      div:nth-child(3) {
        animation-delay: -0.15s;
      }
    }
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }



</style>
